export default __webpack_public_path__ + "static/media/mostBurn.86528f8a.png";